import img from './image.svg'
import { useState, useEffect } from 'react'
import axios from 'axios'

import { Box, Paper, Typography, Container, Divider, Button } from '@mui/material';

const ImageContainer = ({ setIsUploading, setUploaded, setUrl, flag, id, ext }) => {
  const [fileSrc, setFileSrc] = useState()

  const buttonHandler = (img) => {
    setFileSrc(img)
  }

  const addImage = async () => {
    try {
      setIsUploading(true)
      const data = new FormData()
      data.append('myfile', fileSrc)
      let response;
      if (flag) {
        response = await axios.put(`/api/images/${id}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
      } else {
        response = await axios.post('/api/images', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
      }

      if (response.status === 200) {
        setUrl(response.data.filePath)
      }

    } catch (error) {
      console.log(error)
    } finally {
      setTimeout(() => {
        setIsUploading(false)
        setUploaded(true)
      }, 1000)
    }
  }

  useEffect(() => {
    if (!fileSrc) return
    if (ext) {
      if (`.${fileSrc.name.split('.').pop()}` !== ext) {
        alert(`La nueva imagen debe tener la misma extensión que la imagen anterior (${ext})`)
        return
      } else {
        addImage()
      }
    } else {
      addImage()
    }
  }, [fileSrc])

  return (
    <Container maxWidth='xl' style={{ marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper disabled elevation={3} style={{ padding: '48px', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
        <Typography variant='h4' style={{ fontWeight: 700 }}>Subir una Imagen</Typography>
        <Typography variant='body1'>La imagen debe estar en formato .jpg .png ...</Typography>
        <Divider variant="middle" className='my-3' />

        <Box
          className='img-uploader'
          onDragOver={(e) => {
            e.preventDefault()
          }}
          onDrop={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setFileSrc(e.dataTransfer.files[0])
          }}
        >
          <img src={img} style={{ margin: '24px 0px' }} alt='data.svg...' />
          <Typography variant='body1' style={{ fontWeight: 700 }}>Arrastra y suelta una imagen aquí</Typography>
        </Box>

        <Typography variant='body2' style={{ margin: '12px 0px' }}>O</Typography>

        <Button
          variant="contained"
          component="label"
          size='large'
          style={{ margin: '12px 0px' }}
        >
          Buscar ...
          <input
            type='file'
            hidden
            accept='image/*'
            id='file'
            onChange={(e) => buttonHandler(e.target.files[0])}
          />
        </Button>
        <label htmlFor='file'>Explorar Archivos</label>
      </Paper>
    </Container>
  )
}

export default ImageContainer
